module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/3-7a4ab56daac7c7da1aeab7f8afb8661d.webp";